import type { ReactNode } from "react";
import { Link } from "react-router";

import { ChevronRightIcon, IdValue } from "@prequel/shared-components";

import { useDatalake } from "@/api/import/datalakes";
import { useProvider } from "@/api/import/providers";

const LinkedRow = ({ label, name, id, to }: { label: string; name: ReactNode; id: string; to: string }) => (
  <div className="flex items-center justify-between gap-4 text-sm">
    <div className="flex items-center gap-2">
      <span className="text-stone-600">{label}</span>
      <Link
        to={to}
        className="
          flex items-center gap-1 text-stone-800
          hover:underline
        "
      >
        {name}
        <ChevronRightIcon className="text-stone-400" />
      </Link>
    </div>
    <div className="flex items-center gap-2">
      <IdValue id={id} />
    </div>
  </div>
);

/** Provider the resource belongs to, optionally with the datalake that provider writes into. */
const ProviderCard = ({ providerId, showDatalake = false }: { providerId: string; showDatalake?: boolean }) => {
  const { data: provider } = useProvider(providerId);
  const { data: datalake } = useDatalake(provider?.datalake_id ?? "");

  if (!provider) {
    return null;
  }

  return (
    <section className="mb-4 space-y-3 rounded-md border border-stone-200 bg-white px-4 py-3">
      <LinkedRow label="Provider" name={provider.name} id={provider.id} to={`/import/providers/${provider.id}`} />
      {showDatalake && datalake && (
        <>
          <div className="h-px w-full bg-stone-100" />
          <LinkedRow label="Datalake" name={datalake.name} id={datalake.id} to={`/import/datalakes/${datalake.id}`} />
        </>
      )}
    </section>
  );
};

export default ProviderCard;
